import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function vehicleReducer(state = initialState.vehicle, action) {
  switch (action.type) {
    case types.LOAD_VEHICLE_SUCCESS:
      return action.vehicle;
    case types.UPDATE_VEHICLE_SUCCESS:
      return state.map((vehicle) =>
        vehicle.vehicleId === action.vehicle.vehicleId
          ? action.vehicle
          : vehicle
      );
    case types.SAVE_VEHICLE_SUCCESS:
      return [...state, { ...action.vehicle }];
    default:
      return state;
  }
}
